import styled from "styled-components";
import { C, MQ, TYPE } from "Components/WebsiteTheme/WebsiteTheme.style";

/* Contact Us in the Home and About page style: heading and details left, form in a white card right */
export const ContactUsPageContainer = styled.section`
	.cu_grid {
		display: grid;
		grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
		align-items: start;
		gap: 56px;

		${MQ.STACK} {
			grid-template-columns: 1fr;
			gap: 40px;
		}
	}

	.cu_details {
		display: flex;
		flex-direction: column;
		gap: 32px;
	}

	.cu_list {
		display: flex;
		flex-direction: column;
		gap: 16px;

		li {
			display: flex;
			align-items: center;
			gap: 16px;
		}

		.sm_icon {
			width: 48px;
			height: 48px;

			svg {
				width: 22px;
				height: 22px;
			}
		}

		a {
			color: ${C.navy};
			font-size: 17px;
			font-weight: 600;
			overflow-wrap: anywhere;
			transition: color 0.2s ease;

			&:hover {
				color: ${C.blue};
			}
		}
	}

	.cu_social {
		display: flex;
		align-items: center;
		gap: 16px;
		padding-top: 24px;
		border-top: 1px solid ${C.line};

		ul {
			display: flex;
			gap: 10px;
		}

		a {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 40px;
			height: 40px;
			border-radius: 50%;
			background: ${C.blueSoft};
			transition: background 0.2s ease;

			svg {
				max-width: 18px;
				max-height: 18px;
			}

			/* The icons are drawn red; show them in the site blue like the footer */
			svg [fill="#EE2D2F" i] {
				fill: ${C.blue};
			}

			&:hover {
				background: ${C.blueLine};
			}
		}
	}

	.cu_form_card {
		padding: 36px;
		border: 1px solid ${C.line};
		border-radius: 20px;
		background: #fff;
		box-shadow: ${C.cardShadow};

		${MQ.PHONE} {
			padding: 24px 18px;
		}
	}

	.cu_fields {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 4px 20px;

		${MQ.PHONE} {
			grid-template-columns: 1fr;
		}
	}

	.cu_field {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.cu_field--full {
		grid-column: 1 / -1;
	}

	label {
		color: ${C.navy};
		${TYPE.label}
	}

	input,
	textarea {
		width: 100%;
		min-height: 50px;
		padding: 12px 16px;
		border: 1px solid ${C.line};
		border-radius: 10px;
		background: ${C.tint};
		color: ${C.navy};
		font-family: "Outfit", sans-serif;
		font-size: 16px;
		transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

		&::placeholder {
			color: ${C.muted};
		}

		&:hover {
			border-color: ${C.blueLine};
		}

		&:focus {
			border-color: ${C.blue};
			background: #fff;
			box-shadow: 0 0 0 3px rgba(31, 99, 224, 0.15);
			outline: none;
		}

		&[aria-invalid="true"] {
			border-color: #d92d20;
		}
	}

	textarea {
		min-height: 140px;
		resize: vertical;
	}

	/* Keeps the space for a message so the form does not jump */
	.cu_error {
		min-height: 20px;
		color: #d92d20;
		font-size: 13px;
		line-height: 1.4;
	}

	.cu_submit_row {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		gap: 16px 24px;
		margin-top: 20px;

		.sm_btn {
			min-width: 160px;
		}

		.sm_btn[disabled] {
			opacity: 0.7;
			cursor: wait;
			transform: none;
		}

		${MQ.PHONE} {
			flex-direction: column;
			align-items: stretch;
		}
	}

	.cu_spam {
		display: flex;
		align-items: center;
		gap: 8px;

		svg {
			flex-shrink: 0;
			width: 18px;
			height: 18px;
			color: ${C.green};
		}
	}
`;
